/* import __COLOCATED_TEMPLATE__ from './network-quality-indicator.hbs'; */
import { NETWORK_QUALITY_SCORE } from 'frontend/utils/network-connection';
import { classNameBindings, classNames } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { equal, not, reads } from '@ember/object/computed';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './network-quality-indicator.module.scss';

const LEVEL_MAP = {
  0: 0,
  1: 1,
  2: 1,
  3: 2,
  4: 3,
  5: 3,
};

const SVG_NAMES = {
  [NETWORK_QUALITY_SCORE.poor]: 'network-connection-0',
  [NETWORK_QUALITY_SCORE.suboptimal]: 'network-connection-1',
  [NETWORK_QUALITY_SCORE.good]: 'network-connection-2',
  [NETWORK_QUALITY_SCORE.excellent]: 'network-connection-3',
};

const LEVEL_DESCRIPTION = {
  [NETWORK_QUALITY_SCORE.poor]: 'No connection',
  [NETWORK_QUALITY_SCORE.suboptimal]: 'Poor connection',
  [NETWORK_QUALITY_SCORE.good]: 'Average connection',
  [NETWORK_QUALITY_SCORE.excellent]: 'Excellent connection',
};

@classic
@classNameBindings('reconnectingRoom:circleView', 'disabled:hidden')
@classNames('network-quality-container', styles.component)
export default class TwilioNetworkQualityIndicator extends Component {
  @service session;

  @equal('mappedLevel', NETWORK_QUALITY_SCORE.suboptimal) isPoorConnection;
  @equal('level', undefined) isConnecting;
  @not('isPoorConnection') notPoorConnection;
  @not('reconnectingSpeaker') notReconnectingSpeaker;
  @reads('session.roomModel.featureThPreflightApi') featureThPreflightApi;

  @computed('level')
  get mappedLevel() {
    return this.featureThPreflightApi
      ? this.level || NETWORK_QUALITY_SCORE.poor
      : LEVEL_MAP[this.level] || 0;
  }

  @computed('mappedLevel')
  get svgForLevel() {
    return SVG_NAMES[this.mappedLevel];
  }

  @computed('mappedLevel')
  get descriptionForLevel() {
    return LEVEL_DESCRIPTION[this.mappedLevel];
  }
}
